// extracted by mini-css-extract-plugin
module.exports = {"notificationList":"NotificationList_notificationList__nlA6F"};